export function useFormikHelpers({ debug, field, helpers, name }) {
    // Add `debug={true}` to the FormikForm component as a prop
    // for additional logging during development
    const formikOnChange = event => {
        if (debug) {
            console.log(
                `Formik's onChange called for field '${name}' with 'e.target.value':`,
                event.target.value
            );
        }
        field.onChange(event);
    };

    const formikOnBlur = event => {
        if (debug) {
            console.log(
                `Formik's onBlur called for field '${name}' with 'e.target.value':`,
                event.target.value
            );
        }
        field.onBlur(event);
    };

    const formikHelpers = {
        setTouched: bool => {
            if (debug) {
                console.log(
                    `Formik's setTouched called for field '${name}' with value:`,
                    bool
                );
            }
            helpers.setTouched(bool);
        },
        setValue: value => {
            if (debug) {
                console.log(
                    `Formik's setValue called for field '${name}' with value:`,
                    value
                );
            }
            helpers.setValue(value);
        }
    };

    return { formikOnChange, formikOnBlur, formikHelpers };
}
